import { IconButton } from '@folio/stripes/components';
import React, { useCallback } from 'react';
import { useField } from 'react-final-form';
import { useFieldArray } from 'react-final-form-arrays';
import { CriteriaGroupType, CriteriaTerminalType } from '../../types';
export default function CriteriaCardToolbox(_a) {
    var prefix = _a.prefix, _b = _a.root, root = _b === void 0 ? false : _b, _c = _a.alone, alone = _c === void 0 ? false : _c, onRemove = _a.onRemove;
    var type = useField("".concat(prefix, "type"), 
    // format ensures undefined is treated as default (pass)
    {
        subscription: { value: true },
        format: function (value) { return value || CriteriaTerminalType.PASS; },
    }).input.value;
    var criteria = useFieldArray("".concat(prefix, "criteria"));
    var addCallback = useCallback(function () {
        criteria.fields.push({
            type: CriteriaGroupType.ALL_OF,
            criteria: [],
        });
    }, [criteria]);
    return (React.createElement("div", null,
        [CriteriaGroupType.ALL_OF, CriteriaGroupType.ANY_OF, CriteriaGroupType.NONE_OF].includes(type) && React.createElement(IconButton, { icon: "plus-sign", onClick: addCallback }),
        !root && React.createElement(IconButton, { icon: "trash", onClick: onRemove, disabled: alone })));
}
